import { useMemo } from "react";
import { ILead } from "../../../models/Lead";
import LeadNotes from "../LeadInformation/LeadNotes";
import VehicleNotes from "../LeadInformation/VehicleNotes";
import StatusTabs, { StatusTabItem } from "../../shared/Tabs/StatusTabs";
import useNotes from "../../../data/useNotes";
import NotesOutput from "../../shared/Notes/NotesOutput";
import { ResourceType } from "../../../models/Note";

export default function LeadNotesTab({ lead }: { lead: ILead }) {
  const { useNotesByResource } = useNotes();
  const { data } = useNotesByResource(lead.id);

  const callNotes = useMemo(() => {
    return (data?.data ?? []).filter((note) => note.resourceType === ResourceType.Call);
  }, [data]);

  const tabs = useMemo<StatusTabItem[]>(() => {
    return [
      {
        key: "office-notes",
        title: "Office Notes",
        status: lead.officeNotes ? "complete" : "incomplete",
        children: <LeadNotes lead={lead} notesProp="officeNotes" title="Office Notes" />,
      },
      {
        key: "driver-notes",
        title: "Driver Notes",
        status: lead.driverNotes ? "complete" : "incomplete",
        children: <LeadNotes lead={lead} notesProp="driverNotes" title="Driver Notes" />,   
      },
      {
        key: "yard-notes",
        title: "Yard Notes",
        status: lead.yardNotes ? "complete" : "incomplete",
        children: <LeadNotes lead={lead} notesProp="yardNotes" title="Yard Notes" />,   
      },
      {
        key: "vehicle-notes",
        title: "Vehicle Notes",
        status: lead.vehicle?.notes ? "complete" : "incomplete",
        children: <VehicleNotes vehicle={lead.vehicle!} />,   
      },
      {
        key: "call-notes",
        title: "Call Notes",
        status: callNotes.length > 0 ? "complete" : "incomplete",
        children: (
          <div className="p-4">
            <NotesOutput
              resourceId={lead.id}
              resourceType={ResourceType.Call}
              shouldScroll={false}
              notes={callNotes}
              refetchQuery={["notes", lead.id]}
            />
          </div>
        ),
      },
    ];
  }, [callNotes, lead]);

  return <StatusTabs tabs={tabs} defaultTabKey="office-notes" />;
}
